export class ListInventorySensitivityAnnotationValuesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "values",
            "baseName": "values",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventorySensitivityAnnotationValuesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
